import { Button, Card, Spinner } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import CustomModal from '../../../components/Modal/CustomModal'
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal'
import ValidatePaymentModal from '../ValidatePaymentModal/ValidatePaymentModal'
import { AirtimePurchaseProps } from '../AirtimePurchase/AirtimePurchase'
import logo from '../../../assets/Ideos.png'

const ElectricityPurchase = ({hasPin, triggerPinSetup}:AirtimePurchaseProps) => {

    const [providers, setProviders] = useState<any>([])
    const [packages, setPackages] = useState<any>([])
    const [selectedProvider, setSelectedProvider] = useState<any>(null);
    const [selectedPackage, setSelectedPackage] = useState<any>(null)
    const [meterNumber, setMeterNumber] = useState<string>('');
    const [accountDetails, setAccountDetails] = useState<any>()
    const [resolving, setResolving] = useState<boolean>(false)
    const [resolved, setResolved] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [amount, setAmount] = useState<number>(0)
    const [categoryId, setCategoryId] = useState<number>(0)
    const [allGood, setAllGood] = useState<boolean>(false)
    const [openSummaryModal, setOpenSummaryModal] = useState<boolean>(false)
    const [paymentDetails, setPaymentDetails] = useState<any>()
    const [transactionId, setTransactionId] = useState<any>(1)
    const [openValidationModal, setOpenValidationModal] = useState<boolean>(false)
    const [payload, setPayload] = useState<any>(null)


    const handleClick = () => {
        const canProceed = triggerPinSetup();
        console.log(canProceed);

        if (canProceed) {
            setOpenValidationModal(true)
        } else {
            console.log("PIN setup required!");
        }
    }; 

    const validateInputs = () => {
        if (selectedProvider == null || meterNumber == '' || amount == 0 || selectedPackage == null || accountDetails == null) {
            setAllGood(false)
        }
        else {
            setAllGood(true)
        }
    }

    const getProviders = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/bills-payment/electricity/providers/get');

            setProviders(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };


    const getPackages = async (providerId: number) => {
        try {
            const response = await client.get(`/subsidiary/dashboard/bills-payment/biller/${providerId}/packages`);
            console.log(response);

            setPackages(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const resolveAccount = async () => {
        setResolving(true)
        const payload = {
            customerId: meterNumber,
            billerSlug: selectedProvider,
            productName: selectedPackage
        }


        try {
            const response = await client.post(`/subsidiary/dashboard/bills-payment/customer-lookup`, payload);

            setAccountDetails(response.data.data)
            setResolved(true)
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally {
            setResolving(false)
        }
    }

    const handleProviderChange = (providerId: any) => {
        console.log(providerId);
        let providerDetails = providers.find((x: any) => x.id == providerId)
        console.log(providerDetails)
        setCategoryId(providerDetails.billerCategoryId)
        setSelectedProvider(providerDetails.slug);
        setPackages([]);
        getPackages(providerId);
        setResolved(false)
        setAccountDetails('')
    };

    const handlePackageChange = (item: string) => {
        setSelectedPackage(item)
        console.log(item)
        let packageDetails = packages.find((x: any) => x.slug == item)
        console.log(packageDetails);

    }

    useEffect(() => {
        const fetchData = async () => {
            await getProviders()
        }
        fetchData()
    }, [])

    useEffect(() => {
        console.log(selectedPackage, selectedProvider)
        if (meterNumber.length >= 13 && selectedProvider && selectedPackage) {
            resolveAccount()
        }
        else {
            setResolving(false)
            setResolved(false)
        }
    }, [meterNumber, selectedPackage, selectedProvider])

    const constructPayload = () => {
        const payload = {
            customerId: meterNumber,
            billerSlug: selectedProvider,
            amount: amount,
            productName: selectedPackage,
            requiresCustomerLookup: true,
            billType: 'Electricity',
            billCategoryId: categoryId
        }
        setPayload(payload)
    }

    // const initiatePurchase = async () => {
    //     if (amount < 1000) {
    //         showToast("Amount cannot be less than 1000 naira", "error")
    //         return
    //     }
    //     setLoading(true)
    //     const payload = {
    //         customerId: meterNumber,
    //         billerSlug: selectedProvider,
    //         amount: amount,
    //         productName: selectedPackage,
    //         requiresCustomerLookup: true,
    //         billType: 'Electricity',
    //         billCategoryId: categoryId
    //     }
    //     console.log(payload);

    //     try {
    //         const response = await client.post(`/subsidiary/dashboard/bills-payment/process-payment`, payload);
    //         console.log(response.data);
    //         showToast(response.data.message, "success")
    //         // setProviders([])
    //         setAmount(0)
    //         setPackages([])
    //         setTransactionId(response.data.data.id)
    //         setOpenSummaryModal(true)
    //     } catch (err: any) {
    //         if (err?.response?.data?.message === 'Please login again') {
    //             sessionStorage.clear();
    //             window.location.href = '/';
    //         } else {
    //             const message = err?.response?.data?.message;
    //             console.error('error getting data', err);
    //             showToast(message, "error");
    //         }
    //     }
    //     finally {
    //         setLoading(false)
    //     }
    // };

    useEffect(() => {
        validateInputs()
        constructPayload()
    }, [selectedProvider, amount, meterNumber, selectedPackage, accountDetails])

    return (
        <div className='grid grid-cols-1 md:grid-cols-3'>
            <div>
                <p className='text-xl font-semibold'>Electricity Purchase</p>
                <p className='text-xs'>Enter your details to purchase your electricity</p>
            </div>
            <div className='md:col-span-2 mr-8'>
                <Card className='shadow-none'>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <div>
                            <CustomSelectInput label='Service Provider' items={providers} displayKey='name' valueKey='id' onChange={(providerId: any) => handleProviderChange(providerId)} />
                        </div>
                        <div>
                            <CustomSelectInput label='Select Package' items={packages ?? "No package found"} displayKey='name' valueKey='slug' onChange={(slug: string) => handlePackageChange(slug)} />
                        </div>
                        <div>
                            <CustomInput label='Meter Number' name='meterNumber' value={meterNumber} onChange={(e: any) => setMeterNumber(e.target.value)} />
                            {resolving ? (
                                <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                                </div>) : null}
                            {resolved && <span className='text-xs text-green-700'>{accountDetails.customer.customerName}</span>}
                        </div>

                        <CustomInput label='Phone Number' name='phoneNumber' value={accountDetails?.customer?.phoneNumber ?? ""} readonly />
                    </div>
                    <div className='my-0'>
                        <CustomInput type='number' className='mt-0' onFocus={() => amount === 0 && setAmount(NaN)} label='Amount' name='amount' value={amount} onChange={(e: any) => setAmount(e.target.value)} />
                    </div>
                    <div>
                        <p className='text-xs text-green-800 font-bold'>Recent purchase</p>
                    </div>
                    <div className='flex justify-end '>
                        <Button className='w-full md:w-2/6 rounded-sm bg-custom-button-green text-black hover:text-white' disabled={allGood == false} onClick={() =>handleClick()}>{loading ? <Spinner size='sm' /> : 'Buy Electricity'}</Button>
                    </div>
                </Card>
            </div>
            <CustomModal show={openValidationModal} icon='' dismissible onClose={() => setOpenValidationModal(false)} size='md'>
                <ValidatePaymentModal payload={payload} closeVerificationModal={() => setOpenValidationModal(false)} />
            </CustomModal>
        </div>
    )
}

export default ElectricityPurchase
